var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import './index.scss';
import { useAsyncEffect } from 'ii-react-sdk/hooks';
import { LoadingElement } from 'ii-react-sdk/layout_components';
import { DynamicModal } from 'ii-react-sdk/modal_components';
import React, { useEffect, useRef, useState } from 'react';
import PDFViewer from '~/components/pdf_viewer';
import { isNumber } from '~/lib/math';
import { useGrid } from '../../provider';
const DocumentModal = () => {
    const { isDocModalOpen, setIsDocModalOpen, modalDocument, docBookmark } = useGrid();
    const webViewerRef = useRef();
    const [pdf, setPdf] = useState(null);
    useEffect(() => {
        if (!isDocModalOpen)
            setPdf(null);
        if (isDocModalOpen && modalDocument && !pdf)
            setPdf(modalDocument.blob);
    }, [isDocModalOpen]);
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        setPdf(!modalDocument ? null : modalDocument.blob);
    }), [modalDocument]);
    const renderConfAnno = () => {
        if (!webViewerRef.current)
            return;
        const { annotationManager, Annotations, documentViewer } = webViewerRef.current.Core;
        const oldAnnots = annotationManager.getAnnotationsList();
        annotationManager.deleteAnnotations(oldAnnots.filter(a => a.Subject === 'Free Text'), { force: true });
        if (docBookmark.length === 0)
            return;
        const highlight = docBookmark[0].annotations[0];
        if (!isNumber(highlight.confidenceScore))
            return;
        const { x1: rgx1, y1: rgy1, x2: rgx2 } = highlight.coordinates;
        const { pageNum: pageNumber } = highlight;
        if (!isNumber(pageNumber)) {
            window.debugLogger('Cannot render confidence annotation due to invalid page number: ' +
                pageNumber);
            return;
        }
        const pageWidth = Math.floor(documentViewer.getPageWidth(pageNumber));
        const pageHeight = Math.floor(documentViewer.getPageHeight(pageNumber));
        const x1 = Math.floor(rgx1 * pageWidth);
        const y1 = Math.floor(rgy1 * pageHeight);
        const x2 = Math.floor(rgx2 * pageWidth);
        const anno = new Annotations.FreeTextAnnotation(Annotations.FreeTextAnnotation.Intent.FreeText, {
            PageNumber: pageNumber,
            X: x1 + 180 > pageWidth ? x2 - 180 : x1,
            Y: y1 - 30,
            Width: 180,
            Height: 30,
            FontSize: '13px',
            TextAlign: 'center',
            TextVerticalAlign: 'bottom',
            TextColor: new Annotations.Color(0, 0, 255, 1),
            StrokeColor: new Annotations.Color(0, 0, 0, 0.6),
            FillColor: new Annotations.Color(255, 255, 255),
            selectionModel: undefined,
        });
        anno.setContents('Confidence Score: ' + highlight.confidenceScore + '%');
        annotationManager.addAnnotation(anno);
        annotationManager.drawAnnotations({ pageNumber });
    };
    if (!modalDocument)
        return React.createElement(React.Fragment, null);
    return React.createElement(DynamicModal, { className: 'document-modal', visible: isDocModalOpen, onHide: () => setIsDocModalOpen(false), startingHeight: 775, startingWidth: 500 },
        React.createElement("div", { className: 'document-container' },
            React.createElement("h2", { title: modalDocument.fileName }, modalDocument.fileName),
            pdf === null
                ? React.createElement(LoadingElement, { isLightBackground: true, text: 'Loading Document...', heading: true })
                : React.createElement("div", { className: 'document' },
                    React.createElement(PDFViewer, { document: pdf, highlights: docBookmark.flatMap(b => b.annotations), webViewerRef: webViewerRef, onDocumentLoadedCallback: renderConfAnno }))));
};
export default DocumentModal;
